import PDFPreview from '@/components/common/PDFPreview';
import { Box, Flex, Text } from '@chakra-ui/react';

interface Certificate {
  id: string;
  title: string;
  image_url: string;
  date: string;
}

interface CertificatesSectionProps {
  certificates: Certificate[];
  onCertificateClick: (cert: Certificate) => void;
}

export function CertificatesSection({ certificates, onCertificateClick }: CertificatesSectionProps) {
  return (
    <Box px="20px" mb="20px">
      <Text as="h2" fontSize="20px" fontWeight="bold" color="#1e293b" mb="16px" letterSpacing="wide" mt="0">Certificates</Text>
      <Box bg="white" borderRadius="20px" p="20px" boxShadow="0 6px 20px rgba(100,116,139,0.1)" border="1px solid" borderColor="#f1f5f9">
        <Flex
          overflowX="auto"
          overflowY="hidden"
          py="8px"
          px="2px"
          css={{ '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none' }}
        >
          {certificates && certificates.length > 0 ? (
            certificates.map((cert) => (
              <Flex
                key={cert.id}
                as="button"
                aria-label={`Open certificate ${cert.title}`}
                w="160px"
                mr="16px"
                bg="white"
                borderRadius="12px"
                overflow="hidden"
                boxShadow="0 4px 12px rgba(0,0,0,0.08)"
                cursor="pointer"
                flexDir="column"
                flexShrink={0}
                border="none"
                p="0"
                _hover={{ boxShadow: "0 8px 24px rgba(0,0,0,0.12)" }}
                onClick={() => onCertificateClick(cert)}
              >
                <Box w="full" h="85px">
                  <PDFPreview
                    uri={cert.image_url}
                    width={160}
                    height={85}
                  />
                </Box>
                <Box p="10px">
                  <Text as="h3" fontWeight="bold" fontSize="14px" mb="4px" color="black" mt="0">{cert.title}</Text>
                  <Text fontSize="12px" color="volyx.textSecondary" m="0">{cert.date}</Text>
                </Box>
              </Flex>
            ))
          ) : (
            <Flex w="160px" mr="16px" bg="white" borderRadius="12px" overflow="hidden" boxShadow="0 4px 12px rgba(0,0,0,0.08)" border="1px solid" borderColor="volyx.mediumGray" justify="center" align="center" h="140px" p="12px" flexShrink={0}>
              <Text fontSize="12px" color="volyx.textSecondary" textAlign="center" m="0">No certificates uploaded yet.</Text>
            </Flex>
          )}
        </Flex>
      </Box>
    </Box>
  );
}
